<div class="fs-2 with-close" mat-dialog-title>
    Attention !<br/>Votre alerte mail n’est plus active !
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>

    <img class="svg_mail-notif mb-4" src="https://www.lybox.fr/build/images/svg/mobile-notification.svg" alt="Alerte mail">
    <p class="mb-0">
        Votre alerte mail est sur une fréquence qui n’est pas supportée dans votre forfait actuel.
        Gérez votre alerte pour continuer de recevoir de nouvelles annonces
    </p>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()" class="btn btn-outline">
        Fermer
    </button>
    <button type="button" (click)="onYesClick()" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Gérer mon alerte</ng-container>
    </button>
</div>
